import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategoriesSection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-50 mb-3">
            热门分类
          </h2>
          <p className="text-foreground-400 text-sm md:text-base max-w-md mx-auto">
            五大爆料频道，吃瓜全覆盖
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative flex flex-col items-center text-center p-5 md:p-7 rounded-xl bg-background-100/80 hover:bg-background-200 transition-all duration-300 border border-white/10 hover:border-primary-500/40"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-xl bg-primary-500/15 flex items-center justify-center mb-4 group-hover:bg-primary-500/25 transition-colors"
              >
                <i className={`${cat.icon} text-2xl md:text-3xl text-primary-400`} />
              </div>
              <h3 className="text-foreground-100 font-heading font-semibold text-sm md:text-base mb-2 group-hover:text-primary-400 transition-colors"
              >
                {cat.name}
              </h3>
              <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2"
              >
                {cat.description}
              </p>
              <div className="mt-4 flex items-center gap-1 text-primary-400 text-xs font-medium opacity-0 group-hover:opacity-100 transition-opacity"
              >
                <span>立即查看</span>
                <i className="ri-arrow-right-line" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}